import {ExtendedEditorToolType} from '@mc/react-mapio';
import {newItemToolbarChildDef} from '../components/toolbar/ToolbarConst';

/**
 * metoda pro zploštění/deduplikaci toolů
 * vrací pouze pole stringů s typy nástrojů
 */
export const flattenTools = (tools: any): string[] => {
    const resultSet = new Set<string>();

    const addType = (item: any) => {
        if (!item) return;
        if (typeof item === 'string') {
            resultSet.add(item);
            return;
        }
        if (typeof item === 'object' && typeof item.type === 'string' && item.type !== ExtendedEditorToolType.NEW_ITEM) {
            resultSet.add(item.type);
        }
    };

    const traverse = (items: any) => {
        if (!items || !Array.isArray(items)) return;
        for (const item of items) {
            if (item?.items) traverse(item.items);
            addType(item);
        }
    };

    traverse(tools);

    // newItem children: přidáme jejich typy (jen stringy)
    for (const t of newItemToolbarChildDef) {
        let typeStr: string | null = null;
        if (typeof t === 'string') {
            typeStr = t;
        } else if (t && typeof (t as any).type === 'string') {
            typeStr = (t as any).type;
        }
        if (typeStr) resultSet.add(typeStr);
    }

    return Array.from(resultSet);
};
